// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zs2l","content":"styles_content__1dA-F","row":"styles_row__1i_rm","footer":"styles_footer____fh1","phraseLength":"styles_phraseLength__3GgBL"};